// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"868792d7","276":"2cf36abc","647":"4fc1da97","665":"41df0f66","679":"73454ac7","915":"3363375e","916":"fb906725"}[chunkId] + ".chunk.js";
};